// StateBlock.tsx — единый рендер состояний загрузки/ошибки/пустоты внутри карточки.
// Экраны Ф4 показывают его вместо контента, пока данных нет, чтобы не дублировать
// разметку «крутилки» и «ошибки» на каждой странице.

export function StateCard({ kind, message }: { kind: 'loading' | 'error' | 'empty'; message: string }) {
  const color = kind === 'error' ? 'var(--red)' : 'var(--muted)';
  return (
    <div className="card">
      <p style={{ color, margin: 0, textAlign: 'center', padding: '14px 0' }}>{message}</p>
    </div>
  );
}
